export const REPEAT_MODE = {
  doesNotRepeat: 'does_not_repeat',
  oncePerAnchorOccurrence: 'once_per_anchor_occurrence',
  everyNDays: 'every_n_days',
  weeklyOnSelectedDays: 'weekly_on_selected_days',
  everyNWeeks: 'every_n_weeks',
  everyNHours: 'every_n_hours',
  everyNMinutes: 'every_n_minutes',
  everyNMonths: 'every_n_months',
  monthlyOnDay: 'monthly_on_day',
  chapterIntervalUniform: 'chapter_interval_uniform',
  chapterIntervalExplicit: 'chapter_interval_explicit',
  episodicOnSubmission: 'episodic_on_submission',
}

export const REPEAT_MODE_LABELS = {
  [REPEAT_MODE.doesNotRepeat]: "Doesn't repeat",
  [REPEAT_MODE.oncePerAnchorOccurrence]: 'Once per anchor occurrence',
  [REPEAT_MODE.everyNDays]: 'Every N days',
  [REPEAT_MODE.weeklyOnSelectedDays]: 'Weekly on selected days',
  [REPEAT_MODE.everyNWeeks]: 'Every N weeks',
  [REPEAT_MODE.everyNHours]: 'Every N hours',
  [REPEAT_MODE.everyNMinutes]: 'Every N minutes',
  [REPEAT_MODE.everyNMonths]: 'Every N months',
  [REPEAT_MODE.monthlyOnDay]: 'Monthly on day(s) of month',
  [REPEAT_MODE.chapterIntervalUniform]: 'Chapter interval — uniform',
  [REPEAT_MODE.chapterIntervalExplicit]: 'Chapter interval — explicit list',
  [REPEAT_MODE.episodicOnSubmission]: 'Episodic — a new instance opens on each submission',
}

export const getRepeatOptions = ({ chapterBasedTrack = false } = {}) => [
  { key: REPEAT_MODE.doesNotRepeat, text: REPEAT_MODE_LABELS[REPEAT_MODE.doesNotRepeat] },
  { key: REPEAT_MODE.oncePerAnchorOccurrence, text: REPEAT_MODE_LABELS[REPEAT_MODE.oncePerAnchorOccurrence] },
  { key: REPEAT_MODE.everyNDays, text: REPEAT_MODE_LABELS[REPEAT_MODE.everyNDays] },
  { key: REPEAT_MODE.weeklyOnSelectedDays, text: REPEAT_MODE_LABELS[REPEAT_MODE.weeklyOnSelectedDays] },
  { key: REPEAT_MODE.everyNWeeks, text: REPEAT_MODE_LABELS[REPEAT_MODE.everyNWeeks] },
  { key: REPEAT_MODE.everyNHours, text: REPEAT_MODE_LABELS[REPEAT_MODE.everyNHours] },
  { key: REPEAT_MODE.everyNMinutes, text: REPEAT_MODE_LABELS[REPEAT_MODE.everyNMinutes] },
  { key: REPEAT_MODE.everyNMonths, text: REPEAT_MODE_LABELS[REPEAT_MODE.everyNMonths] },
  { key: REPEAT_MODE.monthlyOnDay, text: REPEAT_MODE_LABELS[REPEAT_MODE.monthlyOnDay] },
  {
    key: REPEAT_MODE.chapterIntervalUniform,
    text: REPEAT_MODE_LABELS[REPEAT_MODE.chapterIntervalUniform],
    disabled: !chapterBasedTrack,
  },
  {
    key: REPEAT_MODE.chapterIntervalExplicit,
    text: REPEAT_MODE_LABELS[REPEAT_MODE.chapterIntervalExplicit],
    disabled: !chapterBasedTrack,
  },
  { key: REPEAT_MODE.episodicOnSubmission, text: REPEAT_MODE_LABELS[REPEAT_MODE.episodicOnSubmission] },
]

export const getRepeatPills = ({ chapterBasedTrack = false } = {}) =>
  getRepeatOptions({ chapterBasedTrack }).filter(option => option.key !== REPEAT_MODE.oncePerAnchorOccurrence)

/** @deprecated use REPEAT_MODE */
export const REPEAT_TYPE = {
  none: REPEAT_MODE.doesNotRepeat,
  fixedInterval: REPEAT_MODE.everyNDays,
  calendarDateOfMonth: REPEAT_MODE.monthlyOnDay,
  chapterUniform: REPEAT_MODE.chapterIntervalUniform,
  chapterExplicit: REPEAT_MODE.chapterIntervalExplicit,
}
